module.exports = __webpack_public_path__ + "img/171.d7c58be.svg";